
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/how-it-works/for-sellers",
      function () {
        return require("private-next-pages/how-it-works/for-sellers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/how-it-works/for-sellers"])
      });
    }
  